// 表格公用方法
import { dateFormat } from '@/utils/time.js';

const minxinTable = {
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  // keep-alive进入
  activated() {},
  // keep-alive离开
  deactivated() {},
  created() {
    this.pageSize = this.g_pageSizeDefault;
  },
  methods: {
    // element毫秒级时间戳转成后端需要的秒级时间戳 并 更改时间
    toTimeStamp() {
      let startTime = undefined;
      let endTime = undefined;
      if (this.filter_date && this.filter_date.length > 0) {
        startTime = this.filter_date[0].getTime() / 1000;
        endTime = (this.filter_date[1].getTime() + (60 * 60 * 24 - 1) * 1000) / 1000;
      }
      return { startTime, endTime };
    },
    // 秒级时间戳转格式
    toFormat(value) {
      return dateFormat(new Date(value * 1000), 'YYYY-MM-dd');
    },
  },
};

export { minxinTable };
